module.exports = __webpack_public_path__ + "img/elec_bottom2_us.8d73b7dc.png";